import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import {
  RegistrationStep,
  REGISTRATION_STEP,
} from '../../../constants/registrationStep';

/**
 * メニューカテゴリーの登録画面の状態
 */
interface RegistrationState {
  /** 登録モーダル表示フラグ */
  isOpen: boolean;
  /** 登録ステップ */
  step: RegistrationStep;
}

/**
 * メニューカテゴリー登録画面の初期状態
 */
const initialState: RegistrationState = {
  isOpen: false,
  step: REGISTRATION_STEP.INPUT,
};

/**
 * メニューカテゴリー登録画面の slice(reducer + action)
 */
export const registrationSlice = createSlice({
  name: 'registrationMenuCategory',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (state) => {
      state.isOpen = true;
    },
    updateStep: (
      state,
      { payload }: PayloadAction<RegistrationState['step']>,
    ) => ({
      ...state,
      step: payload,
    }),
  },
});

/**
 * メニューカテゴリー登録画面の action
 */
export const registrationActions = registrationSlice.actions;

/**
 * メニューカテゴリー登録画面の selectors
 */
export const registrationSelectors = {
  isOpenModal: (state: RootState) => state.menuCategory.registration.isOpen,
  currentModalStep: (state: RootState) => state.menuCategory.registration.step,
} as const;
